// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const LensTagsDescription = (props: { limit: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensTagsDescription"
        description="Lens tags description."
        defaultMessage="Add up to {limit} tags to make your lens more discoverable on Snapchat."
        values={props}
    />
);
LensTagsDescription.displayName = "LensTagsDescription";

export const LensTagsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensTagsTooltip"
        description="Lens tags tooltip."
        defaultMessage="Add descriptive tags to help Snapchatters find your Lens on Snapchat."
    />
);
LensTagsTooltip.displayName = "LensTagsTooltip";

export const SpectaclesTagsDescription = (props: { limit: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.spectaclesTagsDescription"
        description="Spectacles tags description."
        defaultMessage="Add up to {limit} tags to make your lens more discoverable on Spectacles."
        values={props}
    />
);
SpectaclesTagsDescription.displayName = "SpectaclesTagsDescription";

export const GameLensTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.gameLensTooltip"
        description="Game lens tooltip."
        defaultMessage="Game Lenses will be full-screen on Snapchat and can be distributed within the Chat drawer for users to play with friends."
    />
);
GameLensTooltip.displayName = "GameLensTooltip";

export const GameLensDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.gameLensDescription"
        description="Game lens description."
        defaultMessage="Lens marked as Game Lens."
    />
);
GameLensDescription.displayName = "GameLensDescription";

export const GameLensSubmittedDescription = (props: { criteriaLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.gameLensSubmittedDescription"
        description="Game lens submitted description."
        defaultMessage="You specified this Lens as a Game Lens. It will go through review to ensure it meets the {criteriaLink}."
        values={props}
    />
);
GameLensSubmittedDescription.displayName = "GameLensSubmittedDescription";

export const GameLensNotApprovedDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.gameLensNotApprovedDescription"
        description="Game lens not approved description."
        defaultMessage="Lens was not marked as a game."
    />
);
GameLensNotApprovedDescription.displayName = "GameLensNotApprovedDescription";

export const GameLensCriteriaLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.gameLensCriteriaLinkText"
        description="Game lens criteria link text."
        defaultMessage="criteria"
    />
);
GameLensCriteriaLinkText.displayName = "GameLensCriteriaLinkText";

export const GameLensLearnMore = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.gameLensLearnMore"
        description="Game lens learn more."
        defaultMessage="Learn More"
    />
);
GameLensLearnMore.displayName = "GameLensLearnMore";

export const ScanTriggersDescription = (props: { limit: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.scanTriggersDescription"
        description="Scan triggers description."
        defaultMessage="Add up to {limit} triggers to make your lens more discoverable on Snapchat."
        values={props}
    />
);
ScanTriggersDescription.displayName = "ScanTriggersDescription";

export const ScanTriggersTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.scanTriggersTooltip"
        description="Scan triggers tooltip."
        defaultMessage="Add scan triggers to help Snapchatters find your Lens via Scan."
    />
);
ScanTriggersTooltip.displayName = "ScanTriggersTooltip";

export const LensDiscoverabilityTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensDiscoverabilityTooltip"
        description="Lens discoverability tooltip."
        defaultMessage="Lens Discoverability Tooltip Placeholder"
    />
);
LensDiscoverabilityTooltip.displayName = "LensDiscoverabilityTooltip";

export const LensDiscoverabilityDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensDiscoverabilityDescription"
        description="Lens discoverability description."
        defaultMessage="Add tags, descriptions, places and time to make your lens more discoverable on Snapchat."
    />
);
LensDiscoverabilityDescription.displayName = "LensDiscoverabilityDescription";

export const LensStatusInReview = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensStatusInReview"
        description="Lens status in review."
        defaultMessage="This Lens is now under review and cannot be updated in the meantime"
    />
);
LensStatusInReview.displayName = "LensStatusInReview";

export const LensStatusLive = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensStatusLive"
        description="Lens status live."
        defaultMessage="All Snapchatters can find and share this Lens"
    />
);
LensStatusLive.displayName = "LensStatusLive";

export const DistributionRestrictionsWarningTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.distributionRestrictionsWarningTitle"
        description="Distribution restrictions warning title."
        defaultMessage="Your Lens has been approved with limited reach."
    />
);
DistributionRestrictionsWarningTitle.displayName = "DistributionRestrictionsWarningTitle";

export const DistributionRestrictionsWarningMessage = (props: { docsLink: ReactNode }): ReactElement => (
    <>
        {" "}
        <FormattedMessage
            id="apps.lens.components.lensSource.distributionRestrictionsWarningMessage"
            description="Distribution restrictions warning message."
            defaultMessage="Your Lens has been approved but may not be promoted to all Snapchatters."
            values={props}
        />
        <br />{" "}
        <FormattedMessage
            id="apps.lens.components.lensSource.distributionRestrictionsWarningMessage"
            description="Distribution restrictions warning message."
            defaultMessage="Please review our {docsLink} and update your Lens so that it’s eligible to reach a larger audience."
            values={props}
        />
    </>
);
DistributionRestrictionsWarningMessage.displayName = "DistributionRestrictionsWarningMessage";

export const DistributionRestrictionsDocsLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.distributionRestrictionsDocsLinkText"
        description="Distribution restrictions docs link text."
        defaultMessage="Lens content requirements"
    />
);
DistributionRestrictionsDocsLinkText.displayName = "DistributionRestrictionsDocsLinkText";

export const DistributionRestrictionsWarningAction = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.distributionRestrictionsWarningAction"
        description="Distribution restrictions warning action."
        defaultMessage="View Reasons"
    />
);
DistributionRestrictionsWarningAction.displayName = "DistributionRestrictionsWarningAction";

export const AvailabilityAds = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.availabilityAds"
        description="Availability ads."
        defaultMessage="Ads"
    />
);
AvailabilityAds.displayName = "AvailabilityAds";

export const AvailabilityTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.availabilityTooltip"
        description="Availability tooltip."
        defaultMessage="Certain requirements must be satisfied for this Lens to be used in Ads."
    />
);
AvailabilityTooltip.displayName = "AvailabilityTooltip";

export const AvailabilityLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.availabilityLabel"
        description="Availability label."
        defaultMessage="Availability"
    />
);
AvailabilityLabel.displayName = "AvailabilityLabel";

export const NotAvailableForAds = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.notAvailableForAds"
        description="Not available for ads."
        defaultMessage="Not available for Ads"
    />
);
NotAvailableForAds.displayName = "NotAvailableForAds";

export const LensBestPracticesLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensBestPracticesLinkText"
        description="Lens best practices link text."
        defaultMessage="Lens Best Practices"
    />
);
LensBestPracticesLinkText.displayName = "LensBestPracticesLinkText";

export const MoreInfoLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.moreInfoLinkText"
        description="More info link text."
        defaultMessage="See Why"
    />
);
MoreInfoLinkText.displayName = "MoreInfoLinkText";

export const CreatorRewardsInsights = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.creatorRewardsInsights"
        description="Creator rewards insights."
        defaultMessage="Top Performer Payouts Insights"
    />
);
CreatorRewardsInsights.displayName = "CreatorRewardsInsights";

export const CreatorRewardsInsightsSubtitle = (props: { learnMoreLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.creatorRewardsInsightsSubtitle"
        description="Creator rewards insights subtitle."
        defaultMessage="Become eligible to receive a payout if your Lens becomes a Top Performer. Enrollment does not guarantee payout. {learnMoreLink}"
        values={props}
    />
);
CreatorRewardsInsightsSubtitle.displayName = "CreatorRewardsInsightsSubtitle";

export const EligibilityPeriod = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.eligibilityPeriod"
        description="Eligibility period."
        defaultMessage="Eligibility Period"
    />
);
EligibilityPeriod.displayName = "EligibilityPeriod";

export const EligibilityPeriodTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.eligibilityPeriodTooltip"
        description="Eligibility period tooltip."
        defaultMessage="The number of days remaining for your lens to earn rewards from the Top Performer Payouts program."
    />
);
EligibilityPeriodTooltip.displayName = "EligibilityPeriodTooltip";

export const TotalQualifiedPosters = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.totalQualifiedPosters"
        description="Total qualified posters."
        defaultMessage="Total Qualified Posters"
    />
);
TotalQualifiedPosters.displayName = "TotalQualifiedPosters";

export const TotalQualifiedPostersTooltip = (props: {
    qualifiedRegionsLink: ReactNode;
    docsLink: ReactNode;
}): ReactElement => (
    <>
        {" "}
        <FormattedMessage
            id="apps.lens.components.lensSource.totalQualifiedPostersTooltip"
            description="Total qualified posters tooltip."
            defaultMessage="The number of unique users who have submitted a post with your lens to Spotlight, Private Stories, and/or Public Stories from {qualifiedRegionsLink}."
            values={props}
        />
        <br />{" "}
        <FormattedMessage
            id="apps.lens.components.lensSource.totalQualifiedPostersTooltip"
            description="Total qualified posters tooltip."
            defaultMessage=" "
            values={props}
        />
        <br />{" "}
        <FormattedMessage
            id="apps.lens.components.lensSource.totalQualifiedPostersTooltip"
            description="Total qualified posters tooltip."
            defaultMessage=" Note: Not all types of lenses are eligible to receive rewards through the program. For more information on which types of lenses qualify, please read the {docsLink} or reach out to support@snap.com."
            values={props}
        />
    </>
);
TotalQualifiedPostersTooltip.displayName = "TotalQualifiedPostersTooltip";

export const QualifiedRegions = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.qualifiedRegions"
        description="Qualified regions."
        defaultMessage="qualified regions"
    />
);
QualifiedRegions.displayName = "QualifiedRegions";

export const Docs = (): ReactElement => (
    <FormattedMessage id="apps.lens.components.lensSource.docs" description="Docs." defaultMessage="docs" />
);
Docs.displayName = "Docs";

export const PostersFromReward = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.postersFromReward"
        description="Posters from reward."
        defaultMessage="away from rewards Eligibility"
    />
);
PostersFromReward.displayName = "PostersFromReward";

export const Qualified = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.qualified"
        description="Qualified."
        defaultMessage="Your Lens is eligible for Rewards!"
    />
);
Qualified.displayName = "Qualified";

export const NumDaysEligible = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.numDaysEligible"
        description="Num days eligible."
        defaultMessage="90 Days"
    />
);
NumDaysEligible.displayName = "NumDaysEligible";

export const StatusPastQualification = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.statusPastQualification"
        description="Status past qualification."
        defaultMessage="This lens is no longer eligible."
    />
);
StatusPastQualification.displayName = "StatusPastQualification";

export const TimeSuffix = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.timeSuffix"
        description="Time suffix."
        defaultMessage="Left"
    />
);
TimeSuffix.displayName = "TimeSuffix";

export const Day = (): ReactElement => (
    <FormattedMessage id="apps.lens.components.lensSource.day" description="Day." defaultMessage="Day" />
);
Day.displayName = "Day";

export const Days = (): ReactElement => (
    <FormattedMessage id="apps.lens.components.lensSource.days" description="Days." defaultMessage="Days" />
);
Days.displayName = "Days";

export const Hour = (): ReactElement => (
    <FormattedMessage id="apps.lens.components.lensSource.hour" description="Hour." defaultMessage="Hour" />
);
Hour.displayName = "Hour";

export const Hours = (): ReactElement => (
    <FormattedMessage id="apps.lens.components.lensSource.hours" description="Hours." defaultMessage="Hours" />
);
Hours.displayName = "Hours";

export const Pending = (): ReactElement => (
    <FormattedMessage id="apps.lens.components.lensSource.pending" description="Pending." defaultMessage="Pending" />
);
Pending.displayName = "Pending";

export const RewardIssued = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.rewardIssued"
        description="Reward issued."
        defaultMessage="Reward Issued"
    />
);
RewardIssued.displayName = "RewardIssued";

export const NoRewardIssued = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.noRewardIssued"
        description="No reward issued."
        defaultMessage="No Reward Issued"
    />
);
NoRewardIssued.displayName = "NoRewardIssued";

export const PendingMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.pendingMessage"
        description="Pending message."
        defaultMessage="Calculating Final Results"
    />
);
PendingMessage.displayName = "PendingMessage";

export const DidNotQualify = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.didNotQualify"
        description="Did not qualify."
        defaultMessage="Did Not Qualify"
    />
);
DidNotQualify.displayName = "DidNotQualify";

export const NoPayoutReceived = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.noPayoutReceived"
        description="No payout received."
        defaultMessage="No Payout Received"
    />
);
NoPayoutReceived.displayName = "NoPayoutReceived";

export const LensDescriptionLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensDescriptionLabel"
        description="Lens description label."
        defaultMessage="Lens Description"
    />
);
LensDescriptionLabel.displayName = "LensDescriptionLabel";

export const LensDescriptionCancel = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensDescriptionCancel"
        description="Lens description cancel."
        defaultMessage="Cancel"
    />
);
LensDescriptionCancel.displayName = "LensDescriptionCancel";

export const LensDescriptionSave = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensDescriptionSave"
        description="Lens description save."
        defaultMessage="Apply"
    />
);
LensDescriptionSave.displayName = "LensDescriptionSave";

export const LensDescriptionEdit = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.lensDescriptionEdit"
        description="Lens description edit."
        defaultMessage="Edit Description"
    />
);
LensDescriptionEdit.displayName = "LensDescriptionEdit";

export const UnsavedChangesTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.unsavedChangesTitle"
        description="Unsaved changes title."
        defaultMessage="Warning, you have unsaved changes"
    />
);
UnsavedChangesTitle.displayName = "UnsavedChangesTitle";

export const UnsavedChangesBody = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.unsavedChangesBody"
        description="Unsaved changes body."
        defaultMessage="All changes will be lost if you continue."
    />
);
UnsavedChangesBody.displayName = "UnsavedChangesBody";

export const UnsavedChangesCancelText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.unsavedChangesCancelText"
        description="Unsaved changes cancel text."
        defaultMessage="Go Back"
    />
);
UnsavedChangesCancelText.displayName = "UnsavedChangesCancelText";

export const UnsavedChangesActionText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.unsavedChangesActionText"
        description="Unsaved changes action text."
        defaultMessage="Discard Changes"
    />
);
UnsavedChangesActionText.displayName = "UnsavedChangesActionText";

export const messages = defineMessages({
    lensTagsLabel: {
        id: "apps.lens.components.lensSource.lensTagsLabel",
        description: "Lens tags label.",
        defaultMessage: "Tags ({curr}/{limit})",
    },
    lensTagsActionLabel: {
        id: "apps.lens.components.lensSource.lensTagsActionLabel",
        description: "Lens tags action label.",
        defaultMessage: "Tags",
    },
    spectaclesTagsLabel: {
        id: "apps.lens.components.lensSource.spectaclesTagsLabel",
        description: "Spectacles tags label.",
        defaultMessage: "Spectacles Tags ({curr}/{limit})",
    },
    spectaclesTagsActionLabel: {
        id: "apps.lens.components.lensSource.spectaclesTagsActionLabel",
        description: "Spectacles tags action label.",
        defaultMessage: "Spectacles Tags",
    },
    gameLensLabel: {
        id: "apps.lens.components.lensSource.gameLensLabel",
        description: "Game lens label.",
        defaultMessage: "Game Lens",
    },
    scanTriggersLabel: {
        id: "apps.lens.components.lensSource.scanTriggersLabel",
        description: "Scan triggers label.",
        defaultMessage: "Scan Triggers ({curr}/{limit})",
    },
    scanTriggersActionLabel: {
        id: "apps.lens.components.lensSource.scanTriggersActionLabel",
        description: "Scan triggers action label.",
        defaultMessage: "Scan Triggers",
    },
    lensDiscoverabilityLabel: {
        id: "apps.lens.components.lensSource.lensDiscoverabilityLabel",
        description: "Lens discoverability label.",
        defaultMessage: "Lens Discoverability",
    },
    lensDiscoverabilityActionLabel: {
        id: "apps.lens.components.lensSource.lensDiscoverabilityActionLabel",
        description: "Lens discoverability action label.",
        defaultMessage: "Tags",
    },
});
